<template>
    <p
        class="control has-icons-right"
        :class="{ 'is-expanded': expanded }">
        <input
            class="input"
            type="text"
            placeholder="Название дисциплины..."
            v-focus
            v-model="options.title">
        <span class="icon is-right is-clickable" @click="$emit('clear')">
            <i class="mdi mdi-close"></i>
        </span>
    </p>
</template>

<script>
export default {
  props: {
    expanded: Boolean,
    options: Object
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/subjects/index/components/NameField.vue